// extracted by mini-css-extract-plugin
export default {"container":"CurriculaDetail_container__HGvdk","backBtn":"CurriculaDetail_backBtn__teAr1"};